export default function PrivacySettings() {
  return <div>Privacy & Security</div>;
} 